var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (g && (g = 0, op[0] && (_ = 0)), _) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
/* eslint-disable no-console */
import { signInWithRedirect, getCurrentUser, fetchAuthSession, signOut } from 'aws-amplify/auth';
import { Hub } from 'aws-amplify/utils';
import { router } from 'components/App/App';
import { CpaRole } from 'models/auth/User';
var getCognitoUserOrSignIn = function () { return __awaiter(void 0, void 0, void 0, function () {
    var user, e_1, routeState;
    return __generator(this, function (_a) {
        switch (_a.label) {
            case 0:
                _a.trys.push([0, 2, , 4]);
                return [4 /*yield*/, getCurrentUser()];
            case 1:
                user = _a.sent();
                return [2 /*return*/, user];
            case 2:
                e_1 = _a.sent();
                routeState = {
                    pathname: window.location.pathname,
                    search: window.location.search,
                    hash: window.location.hash,
                };
                return [4 /*yield*/, signInWithRedirect({
                        provider: {
                            custom: process.env.REACT_APP_COGNITO_IDENTITY_PROVIDER_NAME || 'oneLogin',
                        },
                        customState: JSON.stringify(routeState),
                    })];
            case 3:
                _a.sent();
                throw e_1;
            case 4: return [2 /*return*/];
        }
    });
}); };
export var listenForAuthRedirect = function () {
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    var listener = function (_a) {
        var payload = _a.payload;
        if (payload.event === 'customOAuthState') {
            var _b = JSON.parse(payload.data), pathname = _b.pathname, search = _b.search, hash = _b.hash;
            if (pathname) {
                router.navigate(pathname + search + hash);
            }
        }
        switch (payload.event) {
            case 'signedIn':
                console.log('user signed in');
                break;
            case 'signedOut':
                console.log('user signed out');
                break;
            case 'signInWithRedirect':
                console.log('user signing in with redirect');
                break;
            case 'signInWithRedirect_failure':
                console.log('user sign in failed sending to onelogin');
                break;
            case 'tokenRefresh':
                console.log('token refresh succeeded');
                break;
            case 'tokenRefresh_failure':
                console.log('token refresh failed');
                break;
            case 'configured':
                console.log('the Auth module is configured');
                break;
            case 'customOAuthState':
                console.log('customOAuthState is configured');
                break;
            default:
                console.log('Something Else', payload.event);
        }
    };
    Hub.listen('auth', listener);
};
export function getUserOrSignIn() {
    return __awaiter(this, void 0, Promise, function () {
        var user;
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0: return [4 /*yield*/, getCognitoUserOrSignIn()];
                case 1:
                    _a.sent();
                    return [4 /*yield*/, getUserFromSession()];
                case 2:
                    user = _a.sent();
                    return [2 /*return*/, user];
            }
        });
    });
}
var getUserFromSession = function () { return __awaiter(void 0, void 0, Promise, function () {
    var session, idToken, jwt, groups, upnDetails, upnValue, user;
    var _a, _b, _c;
    return __generator(this, function (_d) {
        switch (_d.label) {
            case 0: return [4 /*yield*/, fetchAuthSession()];
            case 1:
                session = _d.sent();
                idToken = (_a = session.tokens) === null || _a === void 0 ? void 0 : _a.idToken;
                if (!idToken)
                    throw new Error('ID token was null');
                jwt = idToken.payload;
                groups = JSON.parse(jwt['custom:adGroups'] || '[]');
                upnDetails = JSON.parse(jwt['custom:params'] || '{}');
                upnValue = (_c = (_b = upnDetails === null || upnDetails === void 0 ? void 0 : upnDetails.UPN) === null || _b === void 0 ? void 0 : _b.split('@')) === null || _c === void 0 ? void 0 : _c[0];
                user = {
                    email: jwt.email,
                    name: jwt.name,
                    userId: upnValue,
                    groups: groups,
                    cpaRole: deriveCpaRole(groups),
                };
                return [2 /*return*/, user];
        }
    });
}); };
function deriveCpaRole(groups) {
    var _a;
    var env = (_a = process.env.REACT_APP_ENV_NAME) === null || _a === void 0 ? void 0 : _a.toLowerCase();
    var cpaRole;
    if ((groups === null || groups === void 0 ? void 0 : groups.includes("pub_ui_admin_".concat(env))) ||
        ((groups === null || groups === void 0 ? void 0 : groups.includes("pub_ui_cpa_wo_".concat(env))) && (groups === null || groups === void 0 ? void 0 : groups.includes("pub_ui_cpa_sp_".concat(env)))))
        cpaRole = CpaRole.ALL;
    else if (groups === null || groups === void 0 ? void 0 : groups.includes("pub_ui_cpa_wo_".concat(env)))
        cpaRole = CpaRole.WORKORDER;
    else if (groups === null || groups === void 0 ? void 0 : groups.includes("pub_ui_cpa_sp_".concat(env)))
        cpaRole = CpaRole.SPECIALS;
    else
        cpaRole = CpaRole.NONE;
    return cpaRole;
}
export var logoutSession = function () { return __awaiter(void 0, void 0, void 0, function () {
    var error_1;
    return __generator(this, function (_a) {
        switch (_a.label) {
            case 0:
                _a.trys.push([0, 2, , 3]);
                // clear local storage items related to Cognito/AWS Amplify (Amplify 6.x does not always do this automatically on signOut)
                Object.keys(localStorage)
                    .filter(function (key) { return key.startsWith('CognitoIdentityServiceProvider') || key.startsWith('amplify-'); })
                    .forEach(function (key) { return localStorage.removeItem(key); });
                return [4 /*yield*/, signOut({ global: true })];
            case 1:
                _a.sent();
                return [3 /*break*/, 3];
            case 2:
                error_1 = _a.sent();
                console.error('Error during logout:', error_1);
                return [3 /*break*/, 3];
            case 3: return [2 /*return*/];
        }
    });
}); };
export function getCognitoIdToken() {
    var _a, _b;
    return __awaiter(this, void 0, Promise, function () {
        var session;
        return __generator(this, function (_c) {
            switch (_c.label) {
                case 0: return [4 /*yield*/, fetchAuthSession()];
                case 1:
                    session = _c.sent();
                    return [2 /*return*/, ((_b = (_a = session.tokens) === null || _a === void 0 ? void 0 : _a.idToken) === null || _b === void 0 ? void 0 : _b.toString()) || ''];
            }
        });
    });
}
export function checkForCognitoError() {
    var url = new URL(window.location.href);
    var error = url.searchParams.get('error');
    var hasError = !!error;
    return hasError;
}
